import request from './axios';

/**
 * 获取包厢列表
 * @param {Object} params 查询参数
 * @param {Number} params.page 页码
 * @param {Number} params.pageSize 每页条数
 * @param {Number} params.category 分类ID
 * @returns {Promise<Object>} 返回包厢列表和总数
 */
export function getBoxList(params) {
  return request({
    url: '/webapi/boxs/list',
    method: 'get',
    params
  });
}

/**
 * 获取包厢详情
 * @param {String} id 包厢ID
 * @returns {Promise<Object>} 返回包厢详情
 */
export function getBoxDetail(id) {
  return request({
    url: `/webapi/boxs/list/${id}`,
    method: 'get'
  });
}

/**
 * 获取热门包厢
 * @param {Object} params 查询参数
 * @param {Number} params.limit 限制条数
 * @param {Number} params.category 分类ID
 * @returns {Promise<Object>} 返回热门包厢列表
 */
export function getHotBoxes(params) {
  return request({
    url: '/webapi/boxs/toplist',
    method: 'get',
    params
  });
}

/**
 * 获取包厢分类
 * @returns {Promise<Object>} 返回包厢分类列表
 */
export function getBoxCategories() {
  return request({
    url: '/webapi/boxs/categories',
    method: 'get'
  });
} 